import { useEffect, useState } from 'react'
import { useScript } from 'usehooks-ts'
import Link from '@/components/link-component'
import PageWrapper from '@/components/page-wrapper'
import type { JobType } from '@/utils/greenhouse'
import ShieldLoader from '@/components/ui/shield-loader'

export default function CareersPage({ headerNav, footerNav, newsletterForm, job }: JobType) {
  const { greenhouse_id, title, location, department, content } = job
  const [isLoading, setIsLoading] = useState(true)
  const scriptStatus = useScript(`https://boards.greenhouse.io/embed/job_board/js?for=bitwarden`, {
    removeOnUnmount: false,
  })

  useEffect(() => {
    if (scriptStatus === 'ready' && window?.Grnhse?.Iframe) {
      window.Grnhse.Iframe.load(greenhouse_id)
      setIsLoading(false)
    }
  }, [greenhouse_id, scriptStatus])

  return (
    <PageWrapper seo={{ title }} headerNav={headerNav} footerNav={footerNav} newsletterForm={newsletterForm}>
      <section className="max-w-8xl px-5 lg:px-9 m-auto">
        <div className="max-w-3xl py-12">
          <Link
            to="/careers/#open-positions"
            style={{
              display: 'flex',
              alignItems: 'center',
              color: 'primaryBlue',
              margin: '0 0 1rem -7px',
            }}
          >
            <span className="font-bwi text-primaryBlue">&#xe96b;</span>
            Back to Careers
          </Link>
          <h1>{title}</h1>
          <h5>at Bitwarden in {department}</h5>
          <h6>{location}</h6>

          <div
            className="[&_ol]:ml-6 [&_ol]:mb-6 [&_ul]:ml-6 [&_ul]:mb-6 [&_li]:mb-2"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
          {isLoading && <ShieldLoader shieldSize="Small" />}

          <div id="grnhse_app" />

          <Link
            to="/careers/#open-positions"
            style={{
              display: 'flex',
              alignItems: 'center',
              color: 'primaryBlue',
              marginLeft: '-7px',
            }}
          >
            <span className="font-bwi text-primaryBlue">&#xe96b;</span>
            Back to Careers
          </Link>
        </div>
      </section>
    </PageWrapper>
  )
}
